<template>
  <div class="waajo-ai-onboarding   py-4">
    <!-- HERO -->
    <div class="card border-0 shadow-sm mb-4 onboarding-hero">
      <div class="card-body p-4">
        <div class="row align-items-center">
          <div class="col-md-7">
            <h4 class="font-weight-bold mb-2">Waajo AI — Chat AI</h4>
            <p class="text-muted mb-3">
              Ubah balas otomatis menjadi asisten chat yang lebih cerdas. Paham
              konteks, menjawab natural, dan bisa diarahkan sesuai gaya brand
              Anda.
            </p>

            <div class="d-flex flex-wrap gap-2">
              <button v-if="showRegister" class="btn btn-success mr-2" @click="$emit('activate')">
                Aktifkan AI Chat
              </button>
              <button class="btn btn-outline-secondary" @click="scrollToSteps">
                Lihat cara mengaktifkan
              </button>
            </div>
          </div>

          <div class="col-md-5 text-center">
            <!-- SLOT ILUSTRASI -->
            <slot name="illustration">
              <!-- default fallback illustration -->
              <img
                src="@/assets/chat.png" 
                alt="Chat AI Illustration"
                class="img-fluid onboarding-img"
              />
            </slot>
          </div>
        </div>
      </div>
    </div>

    <!-- SIMPLE EXPLAIN -->
    <div class="card border-0 shadow-sm mb-4">
      <div class="card-body">
        <h5 class="font-weight-bold mb-3">Apa itu Chat AI?</h5>
        <p class="text-muted mb-0">
          Chat AI dapat dipahami sebagai versi lanjutan dari balas otomatis. Sistem ini tidak hanya mengirim respons standar, tetapi bertindak sebagai asisten chat yang mampu memahami konteks percakapan, menyesuaikan gaya komunikasi dengan identitas brand, serta mengikuti aturan bisnis yang telah Anda konfigurasi.
          Anda cukup Mengaktifkan <b class="text-black">Mode AI</b> di Chatbot, memberi arahan lewat Prompt System, lalu memilih sumber
          jawaban AI.
        </p>
      </div>
    </div>

    <!-- STEPS -->
    <div ref="stepsSection" class="card border-0 shadow-sm mb-4">
      <div class="card-body">
        <h5 class="font-weight-bold mb-4">Cara mulai pakai Chat AI</h5>

        <div class="row text-center justify-content-center">
          <div class="col-md-3 mb-3">
            <div class="step-box p-3 h-100">
              <div class="step-number">1</div>
              <h6 class="font-weight-bold mt-2">Pilih Auto Reply</h6>
              <p class="text-muted small mb-0">
                Pilih pesan balas otomatis yang ingin menggunakan AI.
              </p>
            </div>
          </div>
          <div class="col-md-3 mb-3">
            <div class="step-box p-3 h-100">
              <div class="step-number">2</div>
              <h6 class="font-weight-bold mt-2">Aktifkan Mode AI</h6>
              <p class="text-muted small mb-0">
                Hidupkan fitur AI pada pengaturan pesan chatbot.
              </p>
            </div>
          </div>

          <!-- <div class="col-md-3 mb-3">
            <div class="step-box p-3 h-100">
              <div class="step-number">2</div>
              <h6 class="font-weight-bold mt-2">Atur Jadwal</h6>
              <p class="text-muted small mb-0">
                Pilih 24 jam, jam kerja, atau luar jam kerja.
              </p>
            </div>
          </div> -->

          <div class="col-md-3 mb-3">
            <div class="step-box p-3 h-100">
              <div class="step-number">3</div>
              <h6 class="font-weight-bold mt-2">Atur Personality AI</h6>
              <p class="text-muted small mb-0">
                Tentukan peran dan gaya komunikasi AI sesuai karakter brand Anda.
              </p>
            </div>
          </div>

          <div class="col-md-3 mb-3">
            <div class="step-box p-3 h-100">
              <div class="step-number">4</div>
              <h6 class="font-weight-bold mt-2">Pilih Mode AI
              </h6>
              <p class="text-muted small mb-0">
                Gunakan Chat Completions atau Knowledge Base sebagai sumber jawaban AI.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODE SELECTION -->
    <div class="card border-0 shadow-sm mb-4">
      <div class="card-body">
        <h5 class="font-weight-bold mb-4">Pilih referensi yang akan dipakai AI saat merespons pesan.</h5>
 
        <div class="row">
          <div class="col-md-6 mb-3">
            <div class="mode-box p-3 h-100">
              <h6 class="font-weight-bold">Chat Completions</h6>
              <p class="text-muted small mb-0">
                Untuk respons berbasis pengetahuan umum AI.
              </p>
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <div class="mode-box p-3 h-100">
              <h6 class="font-weight-bold">Knowledge Base</h6>
              <p class="text-muted small mb-0">
                Untuk respons yang mengacu pada sumber Informasi atau data khusus yang Anda sediakan.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- BOTTOM CTA -->
    <div v-if="showRegister" class="card border-0 shadow-sm text-center p-4 onboarding-cta">
      <h5 class="font-weight-bold mb-2">Sudah punya pesan otomatis?</h5>
      <p class="text-muted mb-3">
        Tinggal aktifkan AI dan arahkan sesuai kebutuhan bisnis Anda.
      </p>

      <button class="btn btn-success px-4" @click="$emit('activate')">
        Mulai aktifkan Chat AI sekarang
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChatAIOnboarding",
  props:{
    showRegister:{
      type: Boolean,
      default: true
    }
  },
  methods: {
    scrollToSteps() {
      this.$refs.stepsSection.scrollIntoView({ behavior: "smooth" });
    },
  },
};
</script>

<style scoped> 

/* HERO */
.onboarding-hero {
  background: linear-gradient(135deg, #f6f9ff, #eef3ff);
  /* border-radius: 12px; */
}

.onboarding-img {
  max-height: 180px;
}

/* STEP BOX */
.step-box {
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  transition: all 0.2s ease;
  background: #ffffff;
}

.step-box:hover {
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);
  transform: translateY(-3px);
}

.step-number {
  width: 36px;
  height: 36px;
  line-height: 36px;
  margin: 0 auto;
  border-radius: 50%;
  background-color: #28a745;
  color: #fff;
  font-weight: bold;
}

/* MODE BOX */
.mode-box {
  border: 1px solid #f0f0f0;
  /* border-radius: 10px; */
  background: #fafafa;
  transition: 0.2s ease;
}

.mode-box:hover {
  background: #f1f7ff;
  border-color: #cce0ff;
}

/* CTA */
.onboarding-cta {
  /* border-radius: 12px; */
  background: #f8f9fa;
}
</style>



// WEBPACK FOOTER //
// src/views/ai/chat/overview/Information.vue